import { Controller } from "stimulus";
var onmount = require("onmount");

export default class extends Controller {
  static values = {
    url: String,
    date: String,
  };

  static targets = ["dateLabel", "content", "todayButton", "forTodayLabel", "searchInput", "clearButton"];

  connect() {
    this.dateValue = new Date().toISOString().split("T")[0];
    this.loadContent();
  }

  previous() {
    this.dateValue = this.offsetDate(-1);
    this.loadContent();
  }

  next() {
    this.dateValue = this.offsetDate(1);
    this.loadContent();
  }

  gotoToday() {
    this.dateValue = new Date().toISOString().split("T")[0];
    this.loadContent();
  }

  search() {
    var query = this.searchInputTarget.value.toLowerCase();
    var rows = $(this.contentTarget).find("table tbody tr");

    rows.each(function () {
      var text = $(this).text().toLowerCase();
      $(this).toggleClass("d-none", query !== "" && text.indexOf(query) === -1);
    });

    if (query !== "") {
      $(this.clearButtonTarget).removeClass("d-none");
    } else {
      $(this.clearButtonTarget).addClass("d-none");
    }

    var $noResults = $(this.contentTarget).find(".js-search-no-results");
    var visibleRows = rows.filter(":not(.d-none)").length;

    if (query !== "" && visibleRows === 0) {
      if ($noResults.length === 0) {
        $(this.contentTarget).append("<div class='text-center py-4 js-search-no-results'>No search results for '" + query + "'</div>");
      } else {
        $noResults.html("No search results for '" + query + "'").removeClass("d-none");
      }
    } else {
      $noResults.remove();
    }
  }

  clearSearch(event) {
    event.preventDefault();
    this.searchInputTarget.value = "";
    $(this.clearButtonTarget).addClass("d-none");
    $(this.contentTarget).find("table tbody tr").removeClass("d-none");
    $(this.contentTarget).find(".js-search-no-results").remove();
  }

  pickDate() {
    var controller = this;

    if (this.flatpickrInstance) {
      this.flatpickrInstance.open();
      return;
    }

    this.flatpickrInstance = flatpickr(this.dateLabelTarget, {
      disableMobile: "true",
      defaultDate: this.dateValue,
      onChange: function (selectedDates) {
        if (selectedDates.length === 1) {
          controller.dateValue = selectedDates[0].toISOString().split("T")[0];
          controller.loadContent();
        }
      },
    });

    this.flatpickrInstance.open();
  }

  disconnect() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
      this.flatpickrInstance = null;
    }
  }

  loadContent() {
    var controller = this;
    var url = this.urlValue;

    if (url.indexOf("?") !== -1) {
      url = url + "&date=" + this.dateValue;
    } else {
      url = url + "?date=" + this.dateValue;
    }

    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = "";
    }

    if (this.hasClearButtonTarget) {
      $(this.clearButtonTarget).addClass("d-none");
    }

    this.contentTarget.innerHTML =
      '<div class="text-center"><div class="spinner spinner-border spinner-border-sm text-primary mx-auto my-4"></div></div>';

    $.ajax({
      url: url,
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "X-CSRF-Token",
          localStorage.getItem("bp-x-csrf-token")
        );
      },
      success: function (html) {
        controller.contentTarget.innerHTML = html;
        controller.updateDateLabel();
        controller.updateTodayVisibility();
        controller.syncFlatpickr();
        $('[data-toggle="tooltip"]').tooltip({ sanitize: false });
        $('[data-toggle="popover"]').popover({ sanitize: false });
        onmount();
      },
      error: function () {
        window.notyf.error(
          "Something went wrong when loading your request. Please try again."
        );
      },
    });
  }

  updateDateLabel() {
    var date = new Date(this.dateValue + "T00:00:00");
    var options = { weekday: "short", month: "short", day: "numeric" };
    var formatted = date.toLocaleDateString("en-US", options);
    this.dateLabelTarget.childNodes[0].textContent = formatted;
  }

  updateTodayVisibility() {
    var today = new Date().toISOString().split("T")[0];
    var isToday = this.dateValue === today;

    if (isToday) {
      $(this.todayButtonTarget).addClass("d-none");
      $(this.forTodayLabelTarget).removeClass("d-none");
    } else {
      $(this.todayButtonTarget).removeClass("d-none");
      $(this.forTodayLabelTarget).addClass("d-none");
    }
  }

  syncFlatpickr() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.setDate(this.dateValue, false);
    }
  }

  offsetDate(days) {
    var date = new Date(this.dateValue + "T00:00:00");
    date.setDate(date.getDate() + days);
    return date.toISOString().split("T")[0];
  }
}
